import { ApplicationConstants } from '../../../../shared/applicationConstants';
import { SharedService } from '../../../../shared/services/sharedService';
import { AuthService } from '../../../../login/services/authService.js';

export class CrearUsuarisService {

    static crearUsersMapa(businessId, numUsuaris, nom, mostrarDerivats){
        let uid = AuthService.getUid();
        return SharedService.httpPost(ApplicationConstants.createUsersFromMap, { entitatUid: uid, businessId: businessId, numAlumnes: numUsuaris, nom: nom, mostrarDerivats: mostrarDerivats}).then((response) => {
            if (response && response.body) {
                if (response.body.status === "ERROR") {
                    return response.body;
                }
                else {
                   return response.body;
                }
            }
        });
    }

}



// WEBPACK FOOTER //
// ./src/perfil/components/crearusuaris-modal/services/crearUsuarisService.js